/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stat_Ats_Pass_ValueInputs */

const en_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

const de_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

const fr_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

const es_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

const it_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

const nl_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

const pl_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

const fi_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

const da_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

const sv_landing_stat_ats_pass_value = /** @type {(inputs: Landing_Stat_Ats_Pass_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

/**
* | output |
* | --- |
* | "6" |
*
* @param {Landing_Stat_Ats_Pass_ValueInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stat_ats_pass_value = /** @type {((inputs?: Landing_Stat_Ats_Pass_ValueInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stat_Ats_Pass_ValueInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stat_ats_pass_value(inputs)
	if (locale === "fr") return fr_landing_stat_ats_pass_value(inputs)
	if (locale === "es") return es_landing_stat_ats_pass_value(inputs)
	if (locale === "it") return it_landing_stat_ats_pass_value(inputs)
	if (locale === "nl") return nl_landing_stat_ats_pass_value(inputs)
	if (locale === "pl") return pl_landing_stat_ats_pass_value(inputs)
	if (locale === "fi") return fi_landing_stat_ats_pass_value(inputs)
	if (locale === "da") return da_landing_stat_ats_pass_value(inputs)
	if (locale === "sv") return sv_landing_stat_ats_pass_value(inputs)
	return en_landing_stat_ats_pass_value(inputs)
});